import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_URL}/api/sales`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const salesAPI = {
  // ── Leads ──────────────────────────────────────────────────────────────────
  getLeads: (params = {}) => api.get('/leads', { params }),
  getEnrichedLeads: (params = {}) => api.get('/leads/enriched', { params }),
  getStats: () => api.get('/leads/stats'),
  getLead: (id) => api.get(`/leads/${id}`),
  createLead: (data) => api.post('/leads', data),
  updateLead: (id, data) => api.put(`/leads/${id}`, data),
  deleteLead: (id, { hard = false } = {}) => api.delete(`/leads/${id}`, { params: hard ? { hard: 'true' } : {} }),

  // ── Status ─────────────────────────────────────────────────────────────────
  updateStatus: (id, status) => api.put(`/leads/${id}/status`, { status }),

  // ── Notes ─────────────────────────────────────────────────────────────────
  addNote: (id, data) => api.post(`/leads/${id}/notes`, data),
  deleteNote: (leadId, noteId) => api.delete(`/leads/${leadId}/notes/${noteId}`),

  // ── Email ─────────────────────────────────────────────────────────────────
  sendEmail: (id, data) => api.post(`/leads/${id}/email`, data),
  sendApplicationReminder: (id) => api.post(`/leads/${id}/application-reminder`),

  // ── Fundings ──────────────────────────────────────────────────────────────
  addFunding: (leadId, data) => api.post(`/leads/${leadId}/fundings`, data),
  updateFunding: (leadId, fundingId, data) => api.put(`/leads/${leadId}/fundings/${fundingId}`, data),
  deleteFunding: (leadId, fundingId) => api.delete(`/leads/${leadId}/fundings/${fundingId}`),

  // ── Submissions ───────────────────────────────────────────────────────────
  addSubmission: (leadId, data) => api.post(`/leads/${leadId}/submissions`, data),
  updateSubmission: (leadId, submissionId, data) => api.put(`/leads/${leadId}/submissions/${submissionId}`, data),
  deleteSubmission: (leadId, submissionId) => api.delete(`/leads/${leadId}/submissions/${submissionId}`),

  // ── Documents ─────────────────────────────────────────────────────────────
  getDocuments: (leadId) => api.get(`/leads/${leadId}/documents`),
  uploadDocument: (leadId, formData) => api.post(`/leads/${leadId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  downloadDocument: (leadId, docId) => `${API_URL}/api/sales/leads/${leadId}/documents/${docId}/download`,
  deleteDocument: (leadId, docId) => api.delete(`/leads/${leadId}/documents/${docId}`),

  // ── CSV Import ────────────────────────────────────────────────────────────
  importCSV: (rows) => api.post('/leads/import-csv', { rows }),
};

export default salesAPI;
